(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3981],{

/***/ 6201:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array ? array.length : 0;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = slice;


/***/ }),

/***/ 8068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atomic_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 6 modules
var esm_Accordion = __webpack_require__(3346);
// EXTERNAL MODULE: ./_hooks/index.js + 2 modules
var _hooks = __webpack_require__(5125);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js
var AccordionButton = __webpack_require__(3621);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/atomic/Accordion/AccordionItem/index.jsx


var _excluded = ["highlighted", "noTitlePadding", "topSpace", "bottomSpace"],
    _excluded2 = ["noBodyMargin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var colors = theme/* theme.colors */.r.colors,
    spaces = theme/* theme.spaces */.r.spaces,
    devices = theme/* theme.devices */.r.devices;
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccordionItem__StyledContainer",
  componentId: "sc-3fxfjr-0"
})(["", " @media ", "{", "}"], function (_ref) {
  var faqList = _ref.faqList;
  return faqList && (0,styled_components_browser_esm/* css */.iv)(["border-bottom:1px solid ", ";padding:20px;"], colors.gray[200]);
}, devices.tablet, function (_ref2) {
  var faqList = _ref2.faqList;
  return faqList && (0,styled_components_browser_esm/* css */.iv)(["padding-left:0px;padding-right:0px;padding-top:16px;padding-bottom:16px;"]);
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledHeader = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var highlighted = _ref3.highlighted,
      noTitlePadding = _ref3.noTitlePadding,
      topSpace = _ref3.topSpace,
      bottomSpace = _ref3.bottomSpace,
      props = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "AccordionItem__StyledHeader",
  componentId: "sc-3fxfjr-1"
})(["display:flex;padding-top:", "px;padding-bottom:", "px;cursor:pointer;", " ", " ", " ", ""], spaces.small2X, spaces.small2X, function (_ref4) {
  var noTitlePadding = _ref4.noTitlePadding;
  return noTitlePadding && (0,styled_components_browser_esm/* css */.iv)(["padding:0;"]);
}, function (_ref5) {
  var highlighted = _ref5.highlighted;
  return highlighted && (0,styled_components_browser_esm/* css */.iv)(["background:", ";"], colors.gray[200]);
}, function (_ref6) {
  var topSpace = _ref6.topSpace;
  return topSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-top:", "px;"], typeof topSpace === 'number' ? topSpace : spaces.regular);
}, function (_ref7) {
  var bottomSpace = _ref7.bottomSpace;
  return bottomSpace && (0,styled_components_browser_esm/* css */.iv)(["margin-bottom:", "px;"], typeof bottomSpace === 'number' ? bottomSpace : spaces.regular);
});
var StyledIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccordionItem__StyledIconContainer",
  componentId: "sc-3fxfjr-2"
})(["display:flex;justify-content:center;align-items:center;margin-left:", "px;"], spaces.regular);
var StyledTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AccordionItem__StyledTitle",
  componentId: "sc-3fxfjr-3"
})(["flex-grow:1;"]); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBody = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref8, ref) {
  var noBodyMargin = _ref8.noBodyMargin,
      props = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "AccordionItem__StyledBody",
  componentId: "sc-3fxfjr-4"
})(["margin-top:", "px;", ""], spaces.regular, function (_ref9) {
  var noBodyMargin = _ref9.noBodyMargin;
  return noBodyMargin && (0,styled_components_browser_esm/* css */.iv)(["margin:0;"]);
});

var AccordionItem = function AccordionItem(_ref10) {
  var eventKey = _ref10.eventKey,
      title = _ref10.title,
      children = _ref10.children,
      open = _ref10.open,
      openIcon = _ref10.openIcon,
      closeIcon = _ref10.closeIcon,
      topSpace = _ref10.topSpace,
      bottomSpace = _ref10.bottomSpace,
      noTitlePadding = _ref10.noTitlePadding,
      noBodyMargin = _ref10.noBodyMargin,
      highlighted = _ref10.highlighted,
      onToggle = _ref10.onToggle,
      faqList = _ref10.faqList;
  var handleToggle = (0,AccordionButton/* useAccordionButton */.k)(eventKey, function () {
    return onToggle && onToggle(eventKey);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
    faqList: faqList,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledHeader, {
      highlighted: highlighted,
      noTitlePadding: noTitlePadding,
      topSpace: topSpace,
      bottomSpace: bottomSpace,
      onClick: handleToggle,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconContainer, {
        children: open ? openIcon : closeIcon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Accordion/* default.Collapse */.Z.Collapse, {
      eventKey: eventKey,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledBody, {
        noBodyMargin: noBodyMargin,
        children: children
      })
    })]
  });
};

/* harmony default export */ var Accordion_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./_components/atomic/Accordion/index.jsx







var Accordion = function Accordion(_ref) {
  var noTitlePadding = _ref.noTitlePadding,
      noBodyMargin = _ref.noBodyMargin,
      openIcon = _ref.openIcon,
      closeIcon = _ref.closeIcon,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onChange = _ref.onChange,
      faqList = _ref.faqList;

  var _useState = (0,react.useState)(false),
      ready = _useState[0],
      setReady = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      openKeys = _useState2[0],
      setOpenKeys = _useState2[1];

  var prevItems = (0,_hooks/* usePrevious */.D)(items);

  var handleToggle = function handleToggle(eventKey) {
    setOpenKeys(function (prevOpenKeys) {
      if (prevOpenKeys.includes(eventKey)) {
        return prevOpenKeys.filter(function (openKey) {
          return openKey !== eventKey;
        });
      }

      return [].concat((0,toConsumableArray/* default */.Z)(prevOpenKeys), [eventKey]);
    });
  };

  (0,react.useEffect)(function () {
    if (!(prevItems !== null && prevItems !== void 0 && prevItems.length) && items.length) {
      setOpenKeys(function () {
        var defaultKeys = [];
        items.forEach(function (_ref2, idx) {
          var openByDefault = _ref2.openByDefault;

          if (openByDefault) {
            defaultKeys.push("".concat(idx));
          }
        });
        return defaultKeys;
      });
    }
  }, [prevItems, items]);
  (0,react.useEffect)(function () {
    onChange && onChange(openKeys);
  }, [openKeys, onChange]);
  (0,react.useEffect)(function () {
    if (openKeys) {
      setReady(true);
    }
  }, [openKeys]);

  if (!ready) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Accordion/* default */.Z, {
    defaultActiveKey: (0,toConsumableArray/* default */.Z)(openKeys),
    alwaysOpen: true,
    children: items.map(function (_ref3, idx) {
      var highlighted = _ref3.highlighted,
          topSpace = _ref3.topSpace,
          bottomSpace = _ref3.bottomSpace,
          title = _ref3.title,
          body = _ref3.body;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion_AccordionItem, {
        eventKey: "".concat(idx),
        title: title,
        open: openKeys.includes("".concat(idx)),
        openIcon: openIcon,
        closeIcon: closeIcon,
        noTitlePadding: noTitlePadding,
        noBodyMargin: noBodyMargin,
        highlighted: highlighted,
        topSpace: topSpace,
        bottomSpace: bottomSpace,
        faqList: faqList,
        onToggle: handleToggle,
        children: body
      }, idx);
    })
  });
};

/* harmony default export */ var atomic_Accordion = (Accordion);

/***/ }),

/***/ 3981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7579);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(934);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6668);
/* harmony import */ var _components_atomic_Accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8068);
/* harmony import */ var _constants_faq__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7851);
/* harmony import */ var _components_atomic_Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(554);
/* harmony import */ var _components_atomic_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8509);
/* harmony import */ var lodash_slice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6201);
/* harmony import */ var lodash_slice__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_slice__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5893);













var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.spaces */ .r.spaces;
var StyledFAQ = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FAQSection__StyledFAQ",
  componentId: "sc-12vjsld-0"
})(["width:750px;margin-left:auto;margin-right:auto;h1{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";}.underHeader{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;text-align:center;color:", ";flex:none;order:1;align-self:stretch;flex-grow:0;margin-bottom:", "px;}.faqContainer{background:", ";border-radius:30px;padding:", "px;.faqDetails{text-align:left;}}.loadMore{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;margin-top:", "px;color:", ";text-align:center;cursor:pointer;}.searchContainer{padding-bottom:", "px;}@media ", "{width:100%;padding-left:", "px;padding-right:", "px;.faqContainer{padding:0px;.faqTitle{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;}.faqDetails{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;}}.searchContainer{padding-top:", "px;padding-bottom:", "px;}.loadMore{font-size:", "px;}}"], fontSizes.large11X, colors.gray[800], fontSizes.large, colors.gray[700], spaces.large6X + 2, colors.white, spaces.largeX + 2, fontSizes.large, spaces.medium, colors.blue[500], spaces.largeX + 2, devices.tablet, spaces.regular, spaces.regular, fontSizes.regular, fontSizes.regular, spaces.regular, spaces.regular, fontSizes.regular);
var Tab = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "FAQSection__Tab",
  componentId: "sc-12vjsld-1"
})(["display:flex;flex-direction:row;align-items:flex-start;padding:", "px ", "px;margin-right:", "px;height:54px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";background:", ";border-radius:", "px ", "px 0px 0px;border-width:0px;@media ", "{margin-right:0px;width:100%;border-radius:", "px;margin-bottom:", "px;font-size:", "px;justify-content:center;background:", ";}"], spaces.small, spaces.large, spaces.small - 2, fontSizes.large, function (_ref) {
  var active = _ref.active;
  return active ? colors.white : colors.gray[500];
}, function (_ref2) {
  var active = _ref2.active;
  return active ? colors.blue[500] : colors.gray[50];
}, spaces.small - 2, spaces.small - 2, devices.tablet, spaces.smallX, spaces.small - 2, fontSizes.regular, function (_ref3) {
  var active = _ref3.active;
  return active ? colors.blue[500] : colors.gray[100];
});
var ButtonGroup = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FAQSection__ButtonGroup",
  componentId: "sc-12vjsld-2"
})(["display:flex;justify-content:center;@media ", "{display:block;}"], devices.tablet);

var FAQSection = function FAQSection(_ref4) {
  var withoutHeader = _ref4.withoutHeader;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      activeSectionTitle = _useState[0],
      setActiveSectionTitle = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      activeSectionItems = _useState2[0],
      setActiveSectionItems = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isCompleted = _useState3[0],
      setIsCompleted = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(5),
      index = _useState4[0],
      setIndex = _useState4[1];

  var initialFaqs = lodash_slice__WEBPACK_IMPORTED_MODULE_8___default()(activeSectionItems, 0, index);

  var loadMore = function loadMore() {
    setIndex(activeSectionItems.length);
    setIsCompleted(true);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setActiveSectionTitle(_constants_faq__WEBPACK_IMPORTED_MODULE_5__/* .FAQ[0].section */ .Z[0].section);
    setActiveSectionItems(_constants_faq__WEBPACK_IMPORTED_MODULE_5__/* .FAQ[0].items */ .Z[0].items);
    setIndex(5);
    setIsCompleted(false);
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledFAQ, {
    children: [!withoutHeader && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h1", {
        children: "FAQs"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "underHeader",
        children: ["Everything you need to know about the trademark.", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("br", {}), " Can't find the answer you're looking for? Chat with our friendly team!"]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(ButtonGroup, {
      children: _constants_faq__WEBPACK_IMPORTED_MODULE_5__/* .FAQ.map */ .Z.map(function (faqSection, idx) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(Tab, {
          active: activeSectionTitle === faqSection.section,
          onClick: function onClick(e) {
            e.preventDefault();
            setActiveSectionTitle(faqSection.section);
            setActiveSectionItems(faqSection.items);
            setIndex(5);
            setIsCompleted(false);
          },
          children: faqSection.section
        }, idx);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "faqContainer",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "searchContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          borderColor: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.gray[200] */ .r.colors.gray[200],
          textColor: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.gray[500] */ .r.colors.gray[500],
          color: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.white */ .r.colors.white,
          hoverColor: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.white */ .r.colors.white,
          hoverTextColor: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.gray[500] */ .r.colors.gray[500],
          placeholder: "Search your question",
          suffix: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            color: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.blue[500] */ .r.colors.blue[500],
            children: "Search"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        faqList: true,
        openIcon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          alias: _constants_icons__WEBPACK_IMPORTED_MODULE_2__/* .ICONS_ALIASES.minus */ .F.minus,
          color: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.gray[500] */ .r.colors.gray[500]
        }),
        closeIcon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          alias: _constants_icons__WEBPACK_IMPORTED_MODULE_2__/* .ICONS_ALIASES.plus */ .F.plus,
          color: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.blue[500] */ .r.colors.blue[500]
        }),
        items: initialFaqs
      }), !isCompleted && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "loadMore",
        onClick: loadMore,
        children: ["Load more", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          alias: _constants_icons__WEBPACK_IMPORTED_MODULE_2__/* .ICONS_ALIASES.more */ .F.more,
          color: _constants_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.blue[500] */ .r.colors.blue[500]
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FAQSection);

/***/ })

}]);